module.exports = __webpack_public_path__ + "static/media/exploded_GreatDodecahedron.319aafda.gif";